<template>
    <div>
        <!-- 头部导航栏 -->
        <div class="moni" style="height:86px">.</div>
        <header class="header">
            <el-row>
                <el-col :span="24">
                    <div class="grid-content bg-purple-dark navigation">
                        <div class="nav-top">
                            <div class="nav-top-left">
                                <div class="nav-top-phone">
                                    400-777-1147
                                </div>
                                <div class="nav-top-email">
                                    chengxie@orancrab.com
                                </div>
                                <div class="nav-top-wechat">
                                    <span @mouseover="dyhshow = !dyhshow" @mouseout="dyhshow = !dyhshow">订阅号：橙蟹</span>
                                    &nbsp;&nbsp;&nbsp;
                                    <span @mouseover="fwhshow = !fwhshow" @mouseout="fwhshow = !fwhshow">服务号：橙蟹有才</span>
                                    <div v-show="dyhshow" class="wccx"><img src="../assets/img/home－image－cx.png" alt=""></div>
                                    <div v-show="fwhshow" class="wccxyc"><img src="../assets/img/home－image－cxyc.png" alt=""></div>
                                </div>

                            </div>

                            <div class="nav-top-right">
                                <a href="http://service.orancrab.com" target="_blank">业务系统登录</a>&nbsp;&nbsp;&nbsp;
                                <a href="http://www.51chengxie.com/pc/cx.html#/pub/login" target="_blank">ERP登录</a>
                            </div>
                        </div>
                        <div class="nav-bottom">
                            <div class="pic">
                                <img src="../assets/img/home-image-logo.jpg" alt="">
                            </div>
                            <div class="navlan">
                                <el-menu class="el-menu-demo" mode="horizontal" active-text-color="#ff5112" @select="handleSelect" :default-active="activeIndex">
                                    <el-menu-item v-for="(list) in navLists" v-if="list.path !== 'tool'" :index='list.path' :key="list.path">{{list.text}}</el-menu-item>
                                    <el-submenu v-else :index='list.path' :key="list.path">
                                        <template slot="title">{{list.text}}</template>
                                        <el-menu-item v-for="item in list.childPath" :key="item.path" :index="item.path">{{item.text}}</el-menu-item>
                                    </el-submenu>
                                </el-menu>
                                <!-- <div class="stop">
                                    <a href="https://h5.youzan.com/v2/showcase/feature?alias=1gamaxj72" target="_blank">商城</a>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </header>

        <router-view />

        <div class="contact">
            <h2>体验财务顾问</h2>
            <el-form ref="form" :model="form" :rules="rules">
                <el-form-item prop="name" style="width:48%;height:5%;display: inline-block">
                    <el-input v-model="form.name" placeholder="*您的名字"></el-input>
                </el-form-item>
                <el-form-item prop="companyName" style="width:48%;height:5%;display: inline-block">
                    <el-input placeholder="*公司名称" v-model="form.companyName"></el-input>
                </el-form-item>
                <el-form-item prop="emianl" style="width:48%;height:5%;display: inline-block">
                    <el-input placeholder="*您的邮箱" v-model="form.emianl"></el-input>
                </el-form-item>
                <el-form-item prop="mobile" style="width:48%;height:5%;display: inline-block">
                    <el-input placeholder="*联系电话" v-model="form.mobile"></el-input>
                </el-form-item>
                <el-form-item prop="content">
                    <el-input style="width:97%" placeholder="*输入咨询问题" type="textarea" v-model="form.content"></el-input>
                </el-form-item>
                <el-form-item size="large" style="text-align:center;">
                    <el-button style="background:#2e324f;color:#fff;" @click="onSubmit('form')">完成并发送</el-button>
                </el-form-item>
            </el-form>

        </div>

        <footer class="footer">
            <div class="f-top">
                <el-row>
                    <el-col :span="6">
                        <div class="f-top-iphon">
                            <h2>400-777-1147</h2>
                            <p>售前支持</p>
                        </div>
                    </el-col>
                    <el-col :span="10">
                        <div class="f-top-email">
                            <h2>chengxie@orancrab.com</h2>
                            <p>商务支持</p>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="f-top-wechat">
                            <div>
                                <img src="../assets/img/home－image－cx.png" alt="">
                                <p style="text-align:center">橙蟹(订阅号)</p>
                            </div>
                            <div>
                                <img src="../assets/img/home－image－cxyc.jpg" alt="">
                                <p style="text-align:center">橙蟹有才(服务号)</p>
                            </div>
							<div>
                                <img src="../assets/img/image-cxqf.jpg" alt="">
                                <p style="text-align:center">橙蟹企服</p>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <div class="f-bottom">
                <div class="f-b-top">
                    <ul>
                        <li><a @click="changeIndex('/product')" href="#" style="border-left:none">产品</a></li>
                        <li><a @click="changeIndex('/customerService')" href="#">客户服务</a></li>
                        <li><a @click="changeIndex('/advisersRecruited')" href="#">顾问招募</a></li>
                        <li><a @click="changeIndex('/about/cxjj')" href="#">橙蟹简介</a></li>
                        <li><a @click="changeIndex('/about/cxys')" href="#">橙蟹优势</a></li>
                        <li><a @click="changeIndex('/about/qyzx')" href="#">企业资讯</a></li>
                        <li><a @click="changeIndex('/about/jrwm')" href="#">加入我们</a></li>
                        <li><a @click="changeIndex('/about/lxwm')" href="#">联系我们</a></li>
                        <li><a @click="changeIndex('/legalNotice')" href="#">法律声明</a></li>
                        <li><a @click="changeIndex('/privacy')" href="#">隐私保护</a></li>
                        <!-- <li><a @click="changeIndex('/activity')" href="#">活动印花</a></li> -->
                    </ul>
                </div>
                <a class="gxb" href="https://beian.miit.gov.cn">版权所属©深圳市云石企业服务有限公司 2021 粤ICP备17024461号</a>
            </div>
        </footer>
    </div>
</template>

<script>
import { addConsultant } from '../api/api.js'
export default {
  name: 'PcIndex',
  beforeCreate: function () {
    document.getElementsByTagName('body')[0].className = 'minWidth'
  },
  data () {
    return {
      url: this.GLOBAL.picURL,
      dyhshow: false,
      fwhshow: false,
      activeIndex: '/homePage',
      navLists: [
        {
          text: '首页',
          path: '/homePage'
        },
        {
          text: '产品',
          path: '/product'
        },
        {
          text: '客户服务',
          path: '/customerService'
        },
        {
          text: '顾问招募',
          path: '/advisersRecruited'
        },
        {
          text: '小工具',
          path: 'tool',
          childPath: [
            {
              text: '橙蟹业务系统平台',
              path: '/business'
            },
            // {
            //     text: "橙蟹报销软件",
            //     path: '/apply',
            // },
            {
              text: '橙蟹财务技能变现与分享平台',
              path: '/cl'
            }]
        },
        {
          text: '关于橙蟹',
          path: '/about/cxjj'
        } ],
      form: {
        name: '',
        companyName: '',
        emianl: '',
        mobile: '',
        content: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入正确姓名', trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        emianl: [
          { type: 'email', required: true, message: '请输入正确的邮箱', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入电话号码', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入咨询问题', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleSelect (key, keyPath) {
      this.$router.push({ path: key })
    },
    changeIndex (key) {
      this.$router.push({ path: key })
    },
    onSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          addConsultant(this.form).then((res) => {
            if (res.status === 1) {
              this.$refs[formName].resetFields()
              this.$message({
                message: '发送成功',
                type: 'success'
              })
            }
          })
        } else {
          return false
        }
      })
    }
  }

}
</script>

<style scoped>
    .el-menu--horizontal {
        border-bottom: none;
    }

    .header {
        background-color: #fff;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99999;
    }

    .header,
    .footer,
    .contact {
        width: 70%;
        padding: 0 15%;
    }

    .header .nav-top {
        height: 26px;
        width: 100%;
        background-color: #fafafa;
        display: flex;
        justify-content: space-between;
    }

    .header .nav-bottom {
        height: 60px;
        width: 100%;
        display: flex;
    }

    .nav-top-phone {
        background: url('../assets/img/home－image－iphon.png') no-repeat;
    }

    .nav-top-email {
        background: url('../assets/img/home－image－email.png') no-repeat;
        margin-left: 32px;
    }

    .nav-top-wechat {
        position: relative;
        background: url('../assets/img/home－image－wechat.png') no-repeat;
        margin-left: 32px;
    }

    .nav-top-phone,
    .nav-top-email,
    .nav-top-wechat {
        background-size: 20px 20px;
        padding-left: 20px;
    }

    .nav-top .nav-top-left {
        display: flex;
        font-size: 12px
    }

    .nav-bottom {
        display: flex;
        justify-content: space-between;
    }

    .nav-bottom .navlan {
        display: flex;
    }

    .pic img {
        margin-top: 12px;
    }

    .navlan .stop a {
        display: block;
        width: 62px;
        height: 32;
        background-color: #ff5112;
        text-align: center;
        line-height: 32px;
        border-radius: 5px;
        margin-top: 12px;
        color: #ffffff;
    }

    .nav-top-right a {
        font-size: 12px;
    }

    /* 底部样式 */
    .footer {
        padding-top: 60px;
        background-color: #2e324f;
    }

    .f-top {
        color: #ffffff
    }

    .f-top .f-top-iphon {
        background: url('../assets/img/home－image－footer-iphon.png') no-repeat;
        padding-left: 75px;
        height: 68px;
        margin-top: 30px
    }

    .f-top .f-top-email {
        background: url('../assets/img/home－image－footer-email.png') no-repeat;
        padding-left: 75px;
        height: 68px;
        margin-top: 30px
    }

    .f-top-wechat {
        display: flex;
    }

    .f-top-wechat div {
        margin-left: 10px;
    }

    .f-bottom {
        padding: 32px 0;
    }

    .f-b-top {
        padding: 6px 0;
        border-bottom: 1px solid #585b72;
        margin-bottom: 10px;
    }

    .gxb {
        color: #585b72;
    }

    .f-b-top ul {
        display: flex;
        flex-wrap: wrap;
    }

    .f-b-top ul a {
        color: #ffffff;
        padding: 0 9px;
        border-left: 1px solid #ffffff;
    }

    /* 财务顾问 */
    .contact h2 {
        color: #2e324f;
        font-size: 32px;
        text-align: center;
        padding: 3% 0;
    }

    /* 二维码 */
    .wccx,
    .wccxyc {
        position: absolute;
        z-index: 999;
    }

    .wccxyc {
        left: 60%;
    }
</style>



// WEBPACK FOOTER //
// src/components/pc_index.vue